var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayoutBlock1X7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1H1V17H17V1ZM1 19H5V23H1V19ZM11 19H7V23H11V19ZM23 1H19V5H23V1ZM23 7H19V11H23V7ZM23 13H19V17H23V13ZM13 19H17V23H13V19ZM23 19H19V23H23V19Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutBlock1X7);
export default __webpack_public_path__ + "static/media/layout-block-1x7.93458425399ce7e5433cb6cd137e1b4e.svg";
export { ForwardRef as ReactComponent };